export const cityList = [
  {
    "name": "abia",
    "cities": [
      "lagos",
      "abuja",
      "ibadan",
      "awka",
      "kano",
      "port harcourt",
      "nneyi-umuleri",
      "onitsha",
      "maiduguri",
      "aba",
      "benin city",
      "shagamu",
      "ikare",
      "ogbomoso",
      "mushin",
      "owerri",
      "ikeja",
      "agege",
      "somolu",
      "sokoto",
      "nnewi",
      "ilesa",
      "minna",
      "apapa",
      "bida",
      "ilobu",
      "ajegunle",
      "oshodi",
      "ifako",
      "surulere",
      "ebute-metta",
      "ojota",
      "ikotun",
      "makera",
      "umundugba",
      "ojo",
      "okrika",
      "uselu",
      "kpor",
      "neni",
      "ozubulu",
      "festac town",
      "buguma",
      "hadejia",
      "amaigbo",
      "ungogo",
      "ikoyi",
      "effurun",
      "dikenafai",
      "kumbotso",
      "nnenasa",
      "ojoto",
      "rumuodomaya",
      "itu",
      "afor-oru",
      "isinweke",
      "ogu",
      "nchia",
      "egbeda",
      "ukpo",
      "abagana",
      "suleja",
    ]
  },
  // {
  //   "name": "abia",
  //   "cities": [
  //     "aba south",
  //     "arochukwu",
  //     "bende",
  //     "ikwuano",
  //     "isiala ngwa north",
  //     "isiala ngwa south",
  //     "isuikwuato",
  //     "obi ngwa",
  //     "ohafia",
  //     "osisioma",
  //     "ugwunagbo",
  //     "ukwa east",
  //     "ukwa west",
  //     "umuahia north",
  //     "umuahia south",
  //     "umu nneochi"
  //   ]
  // },
  // {
  //   "name": "adamawa",
  //   "cities": [
  //     "fufure",
  //     "ganye",
  //     "gayuk",
  //     "gombi",
  //     "grie",
  //     "hong",
  //     "jada",
  //     "lamurde",
  //     "madagali",
  //     "maiha",
  //     "mayo belwa",
  //     "michika",
  //     "mubi north",
  //     "mubi south",
  //     "numan",
  //     "shelleng",
  //     "song",
  //     "toungo",
  //     "yola north",
  //     "yola south"
  //   ]
  // },
  // {
  //   "name": "akwa ibom",
  //   "cities": [
  //     "eastern obolo",
  //     "eket",
  //     "esit eket",
  //     "essien udim",
  //     "etim ekpo",
  //     "etinan",
  //     "ibeno",
  //     "ibesikpo asutan",
  //     "ibiono-ibom",
  //     "ika",
  //     "ikono",
  //     "ikot abasi",
  //     "ikot ekpene",
  //     "ini",
  //     "itu",
  //     "mbo",
  //     "mkpat-enin",
  //     "nsit-atai",
  //     "nsit-ibom",
  //     "nsit-ubium",
  //     "obot akara",
  //     "okobo",
  //     "onna",
  //     "oron",
  //     "oruk anam",
  //     "udung-uko",
  //     "ukanafun",
  //     "uruan",
  //     "urue-offong/oruko",
  //     "uyo"
  //   ]
  // },
  // {
  //   "name": "anambra",
  //   "cities": [
  //     "anambra east",
  //     "anambra west",
  //     "anaocha",
  //     "awka north",
  //     "awka south",
  //     "ayamelum",
  //     "dunukofia",
  //     "ekwusigo",
  //     "idemili north",
  //     "idemili south",
  //     "ihiala",
  //     "njikoka",
  //     "nnewi north",
  //     "nnewi south",
  //     "ogbaru",
  //     "onitsha north",
  //     "onitsha south",
  //     "orumba north",
  //     "orumba south",
  //     "oyi"
  //   ]
  // },
  // {
  //   "name": "bauchi",
  //   "cities": [
  //     "bauchi",
  //     "bogoro",
  //     "damban",
  //     "darazo",
  //     "dass",
  //     "gamawa",
  //     "ganjuwa",
  //     "giade",
  //     "itas/gadau",
  //     "jama'are",
  //     "katagum",
  //     "kirfi",
  //     "misau",
  //     "ningi",
  //     "shira",
  //     "tafawa balewa",
  //     "toro",
  //     "warji",
  //     "zaki"
  //   ]
  // },
  // {
  //   "name": "bayelsa",
  //   "cities": [
  //     "ekeremor",
  //     "kolokuma/opokuma",
  //     "nembe",
  //     "ogbia",
  //     "sagbama",
  //     "southern ijaw",
  //     "yenagoa"
  //   ]
  // },
  // {
  //   "name": "benue",
  //   "cities": [
  //     "apa",
  //     "ado",
  //     "buruku",
  //     "gboko",
  //     "guma",
  //     "gwer east",
  //     "gwer west",
  //     "katsina-ala",
  //     "konshisha",
  //     "kwande",
  //     "logo",
  //     "makurdi",
  //     "obi",
  //     "ogbadibo",
  //     "ohimini",
  //     "oju",
  //     "okpokwu",
  //     "oturkpo",
  //     "tarka",
  //     "ukum",
  //     "ushongo",
  //     "vandeikya"
  //   ]
  // },
  // {
  //   "name": "borno",
  //   "cities": [
  //     "askira/uba",
  //     "bama",
  //     "bayo",
  //     "biu",
  //     "chibok",
  //     "damboa",
  //     "dikwa",
  //     "gubio",
  //     "guzamala",
  //     "gwoza",
  //     "hawul",
  //     "jere",
  //     "kaga",
  //     "kala/balge",
  //     "konduga",
  //     "kukawa",
  //     "kwaya kusar",
  //     "mafa",
  //     "magumeri",
  //     "maiduguri",
  //     "marte",
  //     "mobbar",
  //     "monguno",
  //     "ngala",
  //     "nganzai",
  //     "shani"
  //   ]
  // },
  // {
  //   "name": "cross river",
  //   "cities": [
  //     "akamkpa",
  //     "akpabuyo",
  //     "bakassi",
  //     "bekwarra",
  //     "biase",
  //     "boki",
  //     "calabar municipal",
  //     "calabar south",
  //     "etung",
  //     "ikom",
  //     "obanliku",
  //     "obubra",
  //     "obudu",
  //     "odukpani",
  //     "ogoja",
  //     "yakuur",
  //     "yala"
  //   ]
  // },
  // {
  //   "name": "delta",
  //   "cities": [
  //     "aniocha south",
  //     "bomadi",
  //     "burutu",
  //     "ethiope east",
  //     "ethiope west",
  //     "ika north east",
  //     "ika south",
  //     "isoko north",
  //     "isoko south",
  //     "ndokwa east",
  //     "ndokwa west",
  //     "okpe",
  //     "oshimili north",
  //     "oshimili south",
  //     "patani",
  //     "sapele",
  //     "udu",
  //     "ughelli north",
  //     "ughelli south",
  //     "ukwuani",
  //     "uvwie",
  //     "warri north",
  //     "warri south",
  //     "warri south west"
  //   ]
  // },
  // {
  //   "name": "ebonyi",
  //   "cities": [
  //     "afikpo north",
  //     "afikpo south",
  //     "ebonyi",
  //     "ezza north",
  //     "ezza south",
  //     "ikwo",
  //     "ishielu",
  //     "ivo",
  //     "izzi",
  //     "ohaozara",
  //     "ohaukwu",
  //     "onicha"
  //   ]
  // },
  // {
  //   "name": "edo",
  //   "cities": [
  //     "egor",
  //     "esan central",
  //     "esan north-east",
  //     "esan south-east",
  //     "esan west",
  //     "etsako central",
  //     "etsako east",
  //     "etsako west",
  //     "igueben",
  //     "ikpoba okha",
  //     "orhionmwon",
  //     "oredo",
  //     "ovia north-east",
  //     "ovia south-west",
  //     "owan east",
  //     "owan west",
  //     "uhunmwonde"
  //   ]
  // },
  // {
  //   "name": "ekiti",
  //   "cities": [
  //     "efon",
  //     "ekiti east",
  //     "ekiti south-west",
  //     "ekiti west",
  //     "emure",
  //     "gbonyin",
  //     "ido osi",
  //     "ijero",
  //     "ikere",
  //     "ikole",
  //     "ilejemeje",
  //     "irepodun/ifelodun",
  //     "ise/orun",
  //     "moba",
  //     "oye"
  //   ]
  // },
  // {
  //   "name": "enugu",
  //   "cities": [
  //     "awgu",
  //     "enugu east",
  //     "enugu north",
  //     "enugu south",
  //     "ezeagu",
  //     "igbo etiti",
  //     "igbo eze north",
  //     "igbo eze south",
  //     "isi uzo",
  //     "nkanu east",
  //     "nkanu west",
  //     "nsukka",
  //     "oji river",
  //     "udenu",
  //     "udi",
  //     "uzo uwani"
  //   ]
  // },
  // {
  //   "name": "fct",
  //   "cities": ["bwari", "gwagwalada", "kuje", "kwali", "municipal area council"]
  // },
  // {
  //   "name": "gombe",
  //   "cities": [
  //     "balanga",
  //     "billiri",
  //     "dukku",
  //     "funakaye",
  //     "gombe",
  //     "kaltungo",
  //     "kwami",
  //     "nafada",
  //     "shongom",
  //     "yamaltu/deba"
  //   ]
  // },
  // {
  //   "name": "imo",
  //   "cities": [
  //     "ahiazu mbaise",
  //     "ehime mbano",
  //     "ezinihitte",
  //     "ideato north",
  //     "ideato south",
  //     "ihitte/uboma",
  //     "ikeduru",
  //     "isiala mbano",
  //     "isu",
  //     "mbaitoli",
  //     "ngor okpala",
  //     "njaba",
  //     "nkwerre",
  //     "nwangele",
  //     "obowo",
  //     "oguta",
  //     "ohaji/egbema",
  //     "okigwe",
  //     "orlu",
  //     "orsu",
  //     "oru east",
  //     "oru west",
  //     "owerri municipal",
  //     "owerri north",
  //     "owerri west",
  //     "unuimo"
  //   ]
  // },
  // {
  //   "name": "jigawa",
  //   "cities": [
  //     "babura",
  //     "biriniwa",
  //     "birnin kudu",
  //     "buji",
  //     "dutse",
  //     "gagarawa",
  //     "garki",
  //     "gumel",
  //     "guri",
  //     "gwaram",
  //     "gwiwa",
  //     "hadejia",
  //     "jahun",
  //     "kafin hausa",
  //     "kazaure",
  //     "kiri kasama",
  //     "kiyawa",
  //     "kaugama",
  //     "maigatari",
  //     "malam madori",
  //     "miga",
  //     "ringim",
  //     "roni",
  //     "sule tankarkar",
  //     "taura",
  //     "yankwashi"
  //   ]
  // },
  // {
  //   "name": "kaduna",
  //   "cities": [
  //     "chikun",
  //     "giwa",
  //     "igabi",
  //     "ikara",
  //     "jaba",
  //     "jema'a",
  //     "kachia",
  //     "kaduna north",
  //     "kaduna south",
  //     "kagarko",
  //     "kajuru",
  //     "kaura",
  //     "kauru",
  //     "kubau",
  //     "kudan",
  //     "lere",
  //     "makarfi",
  //     "sabon gari",
  //     "sanga",
  //     "soba",
  //     "zangon kataf",
  //     "zaria"
  //   ]
  // },
  // {
  //   "name": "kano",
  //   "cities": [
  //     "albasu",
  //     "bagwai",
  //     "bebeji",
  //     "bichi",
  //     "bunkure",
  //     "dala",
  //     "dambatta",
  //     "dawakin kudu",
  //     "dawakin tofa",
  //     "doguwa",
  //     "fagge",
  //     "gabasawa",
  //     "garko",
  //     "garun mallam",
  //     "gaya",
  //     "gezawa",
  //     "gwale",
  //     "gwarzo",
  //     "kabo",
  //     "kano municipal",
  //     "karaye",
  //     "kibiya",
  //     "kiru",
  //     "kumbotso",
  //     "kunchi",
  //     "kura",
  //     "madobi",
  //     "makoda",
  //     "minjibir",
  //     "nasarawa",
  //     "rano",
  //     "rimin gado",
  //     "rogo",
  //     "shanono",
  //     "sumaila",
  //     "takai",
  //     "tarauni",
  //     "tofa",
  //     "tsanyawa",
  //     "tudun wada",
  //     "ungogo",
  //     "warawa",
  //     "wudil"
  //   ]
  // },
  // {
  //   "name": "katsina",
  //   "cities": [
  //     "batagarawa",
  //     "batsari",
  //     "baure",
  //     "bindawa",
  //     "charanchi",
  //     "dandume",
  //     "danja",
  //     "dan musa",
  //     "daura",
  //     "dutsi",
  //     "dutsin ma",
  //     "faskari",
  //     "funtua",
  //     "ingawa",
  //     "jibia",
  //     "kafur",
  //     "kaita",
  //     "kankara",
  //     "kankia",
  //     "katsina",
  //     "kurfi",
  //     "kusada",
  //     "mai'adua",
  //     "malumfashi",
  //     "mani",
  //     "mashi",
  //     "matazu",
  //     "musawa",
  //     "rimi",
  //     "sabuwa",
  //     "safana",
  //     "sandamu",
  //     "zango"
  //   ]
  // },
  // {
  //   "name": "kebbi",
  //   "cities": [
  //     "arewa dandi",
  //     "argungu",
  //     "augie",
  //     "bagudo",
  //     "birnin kebbi",
  //     "bunza",
  //     "dandi",
  //     "fakai",
  //     "gwandu",
  //     "jega",
  //     "kalgo",
  //     "koko/besse",
  //     "maiyama",
  //     "ngaski",
  //     "sakaba",
  //     "shanga",
  //     "suru",
  //     "wasagu/danko",
  //     "yauri",
  //     "zuru"
  //   ]
  // },
  // {
  //   "name": "kogi",
  //   "cities": [
  //     "ajaokuta",
  //     "ankpa",
  //     "bassa",
  //     "dekina",
  //     "ibaji",
  //     "idah",
  //     "igalamela odolu",
  //     "ijumu",
  //     "kabba/bunu",
  //     "kogi",
  //     "lokoja",
  //     "mopa muro",
  //     "ofu",
  //     "ogori/magongo",
  //     "okehi",
  //     "okene",
  //     "olamaboro",
  //     "omala",
  //     "yagba east",
  //     "yagba west"
  //   ]
  // },
  // {
  //   "name": "kwara",
  //   "cities": [
  //     "baruten",
  //     "edu",
  //     "ekiti",
  //     "ifelodun",
  //     "ilorin east",
  //     "ilorin south",
  //     "ilorin west",
  //     "irepodun",
  //     "isin",
  //     "kaiama",
  //     "moro",
  //     "offa",
  //     "oke ero",
  //     "oyun",
  //     "pategi"
  //   ]
  // },
  // {
  //   "name": "lagos",
  //   "cities": [
  //     "ajeromi-ifelodun",
  //     "alimosho",
  //     "amuwo-odofin",
  //     "apapa",
  //     "badagry",
  //     "epe",
  //     "eti osa",
  //     "ibeju-lekki",
  //     "ifako-ijaiye",
  //     "ikeja",
  //     "ikorodu",
  //     "kosofe",
  //     "lagos island",
  //     "lagos mainland",
  //     "mushin",
  //     "ojo",
  //     "oshodi-isolo",
  //     "shomolu",
  //     "surulere"
  //   ]
  // },
  // {
  //   "name": "nasarawa",
  //   "cities": [
  //     "awe",
  //     "doma",
  //     "karu",
  //     "keana",
  //     "keffi",
  //     "kokona",
  //     "lafia",
  //     "nasarawa",
  //     "nasarawa egon",
  //     "obi",
  //     "toto",
  //     "wamba"
  //   ]
  // },
  // {
  //   "name": "niger",
  //   "cities": [
  //     "agwara",
  //     "bida",
  //     "borgu",
  //     "bosso",
  //     "chanchaga",
  //     "edati",
  //     "gbako",
  //     "gurara",
  //     "katcha",
  //     "kontagora",
  //     "lapai",
  //     "lavun",
  //     "magama",
  //     "mariga",
  //     "mashegu",
  //     "mokwa",
  //     "moya",
  //     "paikoro",
  //     "rafi",
  //     "rijau",
  //     "shiroro",
  //     "suleja",
  //     "tafa",
  //     "wushishi"
  //   ]
  // },
  // {
  //   "name": "ogun",
  //   "cities": [
  //     "abeokuta south",
  //     "ado-odo/ota",
  //     "egbado north",
  //     "egbado south",
  //     "ewekoro",
  //     "ifo",
  //     "ijebu east",
  //     "ijebu north",
  //     "ijebu north east",
  //     "ijebu ode",
  //     "ikenne",
  //     "imeko afon",
  //     "ipokia",
  //     "obafemi owode",
  //     "odeda",
  //     "odogbolu",
  //     "ogun waterside",
  //     "remo north",
  //     "shagamu"
  //   ]
  // },
  // {
  //   "name": "ondo",
  //   "cities": [
  //     "akoko north-west",
  //     "akoko south-west",
  //     "akoko south-east",
  //     "akure north",
  //     "akure south",
  //     "ese odo",
  //     "idanre",
  //     "ifedore",
  //     "ilaje",
  //     "ile oluji/okeigbo",
  //     "irele",
  //     "odigbo",
  //     "okitipupa",
  //     "ondo east",
  //     "ondo west",
  //     "ose",
  //     "owo"
  //   ]
  // },
  // {
  //   "name": "osun",
  //   "cities": [
  //     "atakunmosa west",
  //     "aiyedaade",
  //     "aiyedire",
  //     "boluwaduro",
  //     "boripe",
  //     "ede north",
  //     "ede south",
  //     "ife central",
  //     "ife east",
  //     "ife north",
  //     "ife south",
  //     "egbedore",
  //     "ejigbo",
  //     "ifedayo",
  //     "ifelodun",
  //     "ila",
  //     "ilesa east",
  //     "ilesa west",
  //     "irepodun",
  //     "irewole",
  //     "isokan",
  //     "iwo",
  //     "obokun",
  //     "odo otin",
  //     "ola oluwa",
  //     "olorunda",
  //     "oriade",
  //     "orolu",
  //     "osogbo"
  //   ]
  // },
  // {
  //   "name": "oyo",
  //   "cities": [
  //     "akinyele",
  //     "atiba",
  //     "atisbo",
  //     "egbeda",
  //     "ibadan north",
  //     "ibadan north-east",
  //     "ibadan north-west",
  //     "ibadan south-east",
  //     "ibadan south-west",
  //     "ibarapa central",
  //     "ibarapa east",
  //     "ibarapa north",
  //     "ido",
  //     "irepo",
  //     "iseyin",
  //     "itesiwaju",
  //     "iwajowa",
  //     "kajola",
  //     "lagelu",
  //     "ogbomosho north",
  //     "ogbomosho south",
  //     "ogo oluwa",
  //     "olorunsogo",
  //     "oluyole",
  //     "ona ara",
  //     "orelope",
  //     "ori ire",
  //     "oyo",
  //     "oyo east",
  //     "saki east",
  //     "saki west",
  //     "surulere"
  //   ]
  // },
  // {
  //   "name": "plateau",
  //   "cities": [
  //     "barkin ladi",
  //     "bassa",
  //     "jos east",
  //     "jos north",
  //     "jos south",
  //     "kanam",
  //     "kanke",
  //     "langtang south",
  //     "langtang north",
  //     "mangu",
  //     "mikang",
  //     "pankshin",
  //     "qua'an pan",
  //     "riyom",
  //     "shendam",
  //     "wase"
  //   ]
  // },
  // {
  //   "name": "rivers",
  //   "cities": [
  //     "ahoada east",
  //     "ahoada west",
  //     "akuku-toru",
  //     "andoni",
  //     "asari-toru",
  //     "bonny",
  //     "degema",
  //     "eleme",
  //     "emuoha",
  //     "etche",
  //     "gokana",
  //     "ikwerre",
  //     "khana",
  //     "obio/akpor",
  //     "ogba/egbema/ndoni",
  //     "ogu/bolo",
  //     "okrika",
  //     "omuma",
  //     "opobo/nkoro",
  //     "oyigbo",
  //     "port harcourt",
  //     "tai"
  //   ]
  // },
  // {
  //   "name": "sokoto",
  //   "cities": [
  //     "bodinga",
  //     "dange shuni",
  //     "gada",
  //     "goronyo",
  //     "gudu",
  //     "gwadabawa",
  //     "illela",
  //     "isa",
  //     "kebbe",
  //     "kware",
  //     "rabah",
  //     "sabon birni",
  //     "shagari",
  //     "silame",
  //     "sokoto north",
  //     "sokoto south",
  //     "tambuwal",
  //     "tangaza",
  //     "tureta",
  //     "wamako",
  //     "wurno",
  //     "yabo"
  //   ]
  // },
  // {
  //   "name": "taraba",
  //   "cities": [
  //     "bali",
  //     "donga",
  //     "gashaka",
  //     "gassol",
  //     "ibi",
  //     "jalingo",
  //     "karim lamido",
  //     "kumi",
  //     "lau",
  //     "sardauna",
  //     "takum",
  //     "ussa",
  //     "wukari",
  //     "yorro",
  //     "zing"
  //   ]
  // },
  // {
  //   "name": "yobe",
  //   "cities": [
  //     "bursari",
  //     "damaturu",
  //     "fika",
  //     "fune",
  //     "geidam",
  //     "gujba",
  //     "gulani",
  //     "jakusko",
  //     "karasuwa",
  //     "machina",
  //     "nangere",
  //     "nguru",
  //     "potiskum",
  //     "tarmuwa",
  //     "yunusari",
  //     "yusufari"
  //   ]
  // },
  // {
  //   "name": "zamfara",
  //   "cities": [
  //     "bakura",
  //     "birnin magaji/kiyaw",
  //     "bukkuyum",
  //     "bungudu",
  //     "gummi",
  //     "gusau",
  //     "kaura namoda",
  //     "maradun",
  //     "maru",
  //     "shinkafi",
  //     "talata mafara",
  //     "chafe",
  //     "zurmi"
  //   ]
  // }
]
